import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export type CursorHookType = 'beforeSubmitPrompt' | 'preToolUse' | 'postToolUse' | 'afterAgentResponse';

export type HookOsType = 'macLinux' | 'windows';

export const CURSOR_HOOKS: CursorHookType[] = [
  'beforeSubmitPrompt',
  'preToolUse',
  'postToolUse',
  'afterAgentResponse',
];

@Injectable({
  providedIn: 'root',
})
export class HooksHttpService {
  private readonly _httpClient = inject(HttpClient);
  private readonly _baseUrl = `${environment.services?.['ai-edge-manager']?.base_url}/${environment.services?.['ai-edge-manager']?.api_version}`;

  public downloadHookScript(
    platform: string,
    hook: CursorHookType,
    integrationId: string,
    os?: HookOsType,
  ): Observable<Blob> {
    let url = `${this._baseUrl}/hooks/${platform}/${hook}` + `?integrationId=${encodeURIComponent(integrationId)}`;
    if (os === 'windows') {
      url += '&os=windows';
    }
    return this._httpClient.get(url, { responseType: 'blob' });
  }
}
